import { render, staticRenderFns } from "./DormList.vue?vue&type=template&id=3d570bbe&scoped=true&"
import script from "./DormList.vue?vue&type=script&lang=js&"
export * from "./DormList.vue?vue&type=script&lang=js&"
import style0 from "./DormList.vue?vue&type=style&index=0&id=3d570bbe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d570bbe",
  null
  
)

export default component.exports